import { FC } from 'react';
import Loginlayout from '../../assets/login_layout.jpg';
import { TabletLayoutImageProps } from './tabletLayoutImage.type';
import { getIdAttributes } from '../../utils/helper';

const TabletLayoutImage: FC<TabletLayoutImageProps> = (props) => {
  const idPrefix: string = 'tablet-layout-image';
  return (
    <img
      src={Loginlayout}
      alt={'Layout'}
      className="absolute inset-0 w-full h-full object-cover"
      {...getIdAttributes(idPrefix, 'image')}
    />
  );
};

export default TabletLayoutImage;
